import { useEffect, useRef } from "react";
import { useIntersectionObserver } from "usehooks-ts";

/**
 *
 * @param cb - Takes a callback that executes when ref element is in view.
 */
const useScrollTrigger = (cb: () => void) => {
  const initialRenderRef = useRef(true);
  const elRef = useRef<HTMLDivElement | null>(null);
  const entry = useIntersectionObserver(elRef, {});

  useEffect(() => {
    // Skip the effect execution on initial component mount
    if (initialRenderRef.current) {
      initialRenderRef.current = false;
      return;
    }

    if (entry?.isIntersecting) {
      // Execute the effect when the dependency changes
      cb();
    }
  }, [entry?.isIntersecting, cb]);

  return {
    ref: elRef,
  };
};

export default useScrollTrigger;
